import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import challengeAnswerService from "../services/challengeAnswerService";

const initialState = {
  challengeAnswer: [],
  error: false,
  success: false,
  loading: false,
  message: null,  
}

export const listChallengeWithStatus = createAsyncThunk(
  "answer/listChallengeWithStatus",
  async (data, thunkAPI) => {
    const res = await challengeAnswerService.listChallengeWithStatus(data.userId);

    return res;
  }
);

export const sendResponse = createAsyncThunk(
  'answer/response',
  async (challengeAnswer, thunkAPI ) => {
    try {
      const data = await challengeAnswerService.sendResponse(challengeAnswer);

      if(!data.errors) return data;

      if (data.errors) {
        return thunkAPI.rejectWithValue(data.errors[0]);
      }

    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAnswersByChallengeId = createAsyncThunk(
  "answer/get",
  async (data, thunkAPI) => {

    const res = await challengeAnswerService.getAnswersByChallengeId(data.userId, data.challengeId);

    return res;
  }
);

export const challengeAnswerSlice = createSlice({
  name: "challengeAnswer",
  initialState,
  reducers: {
    resetMessage: (state) => {
      state.message = null;
    }
  },
  extraReducers: (builder) =>{
    builder
      .addCase(sendResponse.pending, (state) => {
        state.profile = true;
        state.error = null;
      })
      .addCase(sendResponse.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challengeAnswer = action.payload;
      })
      .addCase(getAnswersByChallengeId.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(getAnswersByChallengeId.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challengeAnswer = action.payload;
        state.message = "Lista atualizada com sucesso";
      })
      .addCase(getAnswersByChallengeId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challengeAnswer = null;
      })
      .addCase(listChallengeWithStatus.pending, (state) => {
        state.loading = true;
        state.error = false;
        state.message = "Carregando";
      })
      .addCase(listChallengeWithStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.challengeAnswer = action.payload;
        state.message = "Listagem carregada com sucesso";
      })
      .addCase(listChallengeWithStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.challengeAnswer = null;
        state.message = "Dados não encontrados";
      });
  }
});

export const {resetMessage} = challengeAnswerSlice.actions;
export default challengeAnswerSlice.reducer;